export default __webpack_public_path__ + "static/media/backgroung.0cb13e4a.png";